import { Height } from "@mui/icons-material";
import { Button } from "antd";
import React from "react";

const ManualResponse = ({
  isOpen,
  onClose,
  text,
  desc,
  buttonTextOne,
  buttonTextTwo,
  placeholder,
  loading,
  Second,
  answer,
  handleSubmit,
}) => {
  if (!isOpen) return null;

  const divStyle = {
    backgroundImage: "url(/popup-bg-image.svg)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",         
    width: "100%",
  };

 

  return (
    <div className="fixed inset-0 bg-opacity-70 bg-black flex z-50 items-center justify-center">
      <div
        style={divStyle}
        className="bg-white fixed rounded-lg shadow-lg px-[1%] py-[0.5%] flex flex-col gap-1 items-center w-full h-full max-h-[400px] max-w-2xl overflow-y-auto"
      >
        <img
          src="/cross-popup.svg"
          onClick={onClose}
          className="flex self-end w-10 cursor-pointer"
        />
        <h2 className="text-2xl font-medium px-8 text-black">{text}</h2>
        {desc && <p className="px-6 mt-1">{desc}</p>}
        <form  className="w-full" onSubmit={handleSubmit}>
        <div className="mx-8 mt-4 flex flex-col gap-4">
            
          {Second =="Answer" && <div className="flex flex-col">
            <label className="mb-1">Add Question</label>
            <input
              type="text"
              required
              name="question"
              placeholder={placeholder || "Enter your question"}
              className="p-2 border border-gray-300 rounded custom-outline"
            />
          </div>}

          <div className="flex flex-col">
            <label className="mb-1">{Second}</label>
            <textarea
              value={answer}
              required
              name="answer"
              placeholder={`Enter your ${Second}`}
              className="p-2 h-24 border border-gray-300 rounded custom-outline resize-none"
            />
          </div>
        </div>

        <div className="flex justify-center items-center gap-3 mt-5">
          <Button
            loading={loading}
            type="primary"
            htmlType="submit"
            className="primary custom-btn px-4 py-5"
            style={{
              borderRadius: "0px",
              transition: "none",
            }}
          >
            {buttonTextOne}
          </Button>

          {buttonTextTwo && (
            <button onClick={onClose} className="secondary px-4 py-2">
              {buttonTextTwo}
            </button>
          )}
        </div>
        </form>
      </div>
    
    </div>
  );
};

export default ManualResponse;
